import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Cookies from "universal-cookie";
import moment from "moment-timezone";

import { Button, Col, Row, Table, Space, Tag } from "antd";
import { EyeOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";

const ViewUser = (props) => {
    const params = useParams();
    const cookies = new Cookies();
    const auth = cookies.get("authToken");
    const config = { headers: { "auth-token": auth } };
    const [userDetail, setUserDetail] = useState(null);
    const value = { userID: params.userID };

    useEffect(() => {
        const fetchUserDetail = async () => {
            await axios.post("/api/user/getUserDetail", value, config).then((response) => {
                console.log(response.data);
                setUserDetail(response.data[0]);
            });
        };
        fetchUserDetail();
    }, [params]);

    return (
        <>
            <h1 style={{ textTransform: "uppercase", marginBottom: "15px" }}>View</h1>
            {/* {users && users.length > 0 && users.map((user) => <>{user.firstname}</>)} */}
            {userDetail && userDetail.id}
        </>
    );
};

export default ViewUser;
